import React, {Component, createRef} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import './VehicleOut.scss';

import commonConstant from '../../common/_commonConstant';
import { Loading } from '..';
import { fetchUpdateStatusCarExit } from '../../actions';
import {
  Modal,
  vehicleLicensePlate,
  dateDDMMYYFormat,
  getTimeHHMM,
  getTimeHHMMSS,
  dateYYYYMMDD,
  parkingID,
  Dropdown, validateVehiclePlate
} from '../../helpers';
import {randomNumber} from "../../common/_commonFunction";

class VehicleOut extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'time': null,
      'loading': false,
      'parkingGatePosition': ''
    };
    this.parkingGatePosition = createRef()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { modal, carExit } = this.props;

    if (nextProps.modal && nextProps.modal !== modal) {
      return this.setState({ 'time': new Date() });
    } else if (nextProps.carExit && nextProps.carExit && nextProps.carExit !== carExit) {
      return this.setState({ 'loading': false });
    }
  }

  handleUpdateStatus = () => {
    const { getParkingStatusById } = this.props;
    const { time, parkingGatePosition } = this.state;
    if (!parkingGatePosition) {
      return null;
    }

    this.props.dispatch(fetchUpdateStatusCarExit(parkingID(getParkingStatusById), { 'parkingTimeOut': `${dateYYYYMMDD(time)} ${getTimeHHMMSS(time)}`, 'parkingGateOut': `OUT-${parkingGatePosition.buildingIotDevicePosition}` }));
    return this.setState({ 'loading': true });
  }

  handleEvent = (event, key) => {

   if (key === 'parkingGatePosition') {
      if (event && !event?.target?.value) {
        this.setState({[key]: event});
        this.parkingGatePosition.current.handleShowItem();
      }
    }
  }
  handleParkingPositionDropdownItems = () => {
    try {
      const {parkingGatePosition} = this.state;
      const {iotDevices} = this.props;

      return iotDevices.OUT.map((ele, index) => (
        <div
          id={`parking-gate-position-${index}`}
          className={`item${parkingGatePosition === ele.buildingIotDevicePosition ? ' active' : ''}`}
          key={randomNumber()}
          onClick={() => this.handleEvent(ele, 'parkingGatePosition')}
        >
          <span>{`Gate - ${ele.buildingIotDevicePosition}`}</span>
        </div>
      ));

    } catch (error) {
      return null;
    }
  }


  render() {
    const { handleShow, modal, getParkingStatusById } = this.props;
    const { time, loading, parkingGatePosition } = this.state;

    return (
      <Modal show={modal} handleToggle={handleShow} >
        {loading ? <Loading /> : null}
        <div className="VehicleOut">
          <div className="box-close">
            <span className="icon fas fa-times" id="btn-close-modal" onClick={handleShow} />
          </div>
          <img className="icon" src={commonConstant.carOutImg} alt="" />
          <div className="title">นำรถออก เลขทะเบียน</div>
          <div className="car-plate" id="car-out-license-plate">{vehicleLicensePlate(getParkingStatusById)}</div>
          <div className="time-out">เวลาออก</div>
          <div className="time" id="car-out-time">วันที่ {dateDDMMYYFormat(time)} เวลา {getTimeHHMM(time)}</div>
          <div className="parking-gate-out-container">
            <div className="parking-gate-out-container-label">
              <span className="location-icon-container"><img className="location-icon" src={commonConstant.locationImage}/></span>
             <span>กรุณาเลือกทางออก**</span>
            </div>
            <div className="parking-gate-location-drop-down-container">
              <div className="parking-gate-location-drop-down-label">Position**</div>
              <Dropdown
                id="parking-gate-location-dropdown"
                template="a"
                placeholder="Position"
                value={parkingGatePosition ? `Gate - ${parkingGatePosition.buildingIotDevicePosition}` : null}
                ref={this.parkingGatePosition}
              >
                {this.handleParkingPositionDropdownItems()}
              </Dropdown>
            </div>
            <div className="divider"/>
          </div>
          <div className="box-btn">
            <Button className="btn-fiftary" id="btn-cancel" onClick={handleShow}>
              ยกเลิก
            </Button>
            <Button className="btn-primary" id="btn-confirm" onClick={this.handleUpdateStatus}>
              ยืนยัน
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

VehicleOut.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'myForwardedRef': PropTypes.any,
  'modal': PropTypes.bool,
  'handleShow': PropTypes.func,
  'getParkingStatusById': PropTypes.shape({
    'parkingID': PropTypes.string,
  }),
  'carExit': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({}),
  }),
};

const mapStateToProps = ({ getParkingStatusById, carExit, iotDevices }) => ({ 'getParkingStatusById': getParkingStatusById.data, carExit, 'iotDevices': iotDevices.data, });

export default connect(mapStateToProps)(VehicleOut);
